import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { HtmlBlock } from '@sola/ark-core/atoms/html/html.tsx';
import { TabGroup } from '@sola/ark-core/molecules/tab-group/tab-group.tsx';
import type { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { countryToIso } from '@sola/schema/dotcom/shared/geo.ts';
import { getAge } from '../../utils/child-bio.ts';
import { ChildBioDetailsOverview } from './child-bio-details-overview.tsx';
export const ChildBioTabs = t0 => {
  const $ = _c(44);
  const {
    seoLevel: t1,
    details
  } = t0;
  const seoLevel = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["bio", "geo"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  const {
    ageInYearsAndMonths,
    country,
    localId,
    name,
    hangul
  } = details;
  let t3;
  if ($[1] !== ageInYearsAndMonths) {
    t3 = getAge(ageInYearsAndMonths);
    $[1] = ageInYearsAndMonths;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const age = t3;
  const isToddler = age === "1" || age === "2";
  let communityDescription;
  let t4;
  if ($[3] !== country || $[4] !== localId || $[5] !== t) {
    const countryIso = countryToIso(country, localId);
    communityDescription = t("bio:community", {
      context: countryIso
    });
    t4 = t("bio:description", {
      context: countryIso
    });
    $[3] = country;
    $[4] = localId;
    $[5] = t;
    $[6] = communityDescription;
    $[7] = t4;
  } else {
    communityDescription = $[6];
    t4 = $[7];
  }
  const countryDescription = t4;
  const t5 = seoLevel + 1;
  let t6;
  if ($[8] !== t) {
    t6 = t("bio:overview");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== details || $[11] !== hangul || $[12] !== isToddler || $[13] !== name || $[14] !== seoLevel || $[15] !== t) {
    t7 = isToddler ? <HtmlBlock htmlString={t("bio:babyParagraphs", {
      childName: name.preferred,
      koreanName: hangul.preferred || name.preferred
    })} /> : <ChildBioDetailsOverview seoLevel={seoLevel} details={details} />;
    $[10] = details;
    $[11] = hangul;
    $[12] = isToddler;
    $[13] = name;
    $[14] = seoLevel;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = {
      seoLevel: t5,
      title: t6,
      tabKey: "overview",
      body: t7
    };
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const overviewTab = t8;
  const t9 = seoLevel + 1;
  let t10;
  if ($[21] !== t) {
    t10 = t("bio:community");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = communityDescription as string;
  let t12;
  if ($[23] !== t11) {
    t12 = <HtmlBlock htmlString={t11} />;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12 || $[27] !== t9) {
    t13 = {
      seoLevel: t9,
      title: t10,
      tabKey: "community",
      body: t12
    };
    $[25] = t10;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const communityTab = t13;
  const t14 = seoLevel + 1;
  let t15;
  if ($[29] !== t) {
    t15 = t("bio:country");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  const t16 = countryDescription as string;
  let t17;
  if ($[31] !== t16) {
    t17 = <HtmlBlock htmlString={t16} />;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t14 || $[34] !== t15 || $[35] !== t17) {
    t18 = {
      seoLevel: t14,
      title: t15,
      tabKey: "country",
      body: t17
    };
    $[33] = t14;
    $[34] = t15;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  const countryTab = t18;
  let t19;
  if ($[37] !== communityTab || $[38] !== countryTab || $[39] !== overviewTab) {
    t19 = [overviewTab, communityTab, countryTab];
    $[37] = communityTab;
    $[38] = countryTab;
    $[39] = overviewTab;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== overviewTab.tabKey || $[42] !== t19) {
    t20 = <TabGroup activeValue={overviewTab.tabKey} items={t19} />;
    $[41] = overviewTab.tabKey;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  return t20;
};